import {useState, useEffect, useRef} from 'react'
import { useAuthApp } from '../../app/auth';
import '../../../css/header.css';
import { Link, useNavigate } from 'react-router-dom';
import UserData from '../plugins/UserData';
import { useTranslation } from "react-i18next";


function ProductOverviewHeader() {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang); // Change the language

    localStorage.setItem('language', lang);

};
  return (
    <>
    <header>
        <nav className="navbar">
            
        <div className="language-switcher">
            <a onClick={() => handleLanguageChange('en')} className="lang-btn">
                EN
            </a>
            <span className="seperator">|</span>
            <a onClick={() => handleLanguageChange('de')} className="lang-btn">
                DE
            </a>
        </div>
        </nav>
    </header>
    </>
  )
}

export default ProductOverviewHeader